import { Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import AudioLoadingDescription from '../../../components/Accessibility/AudioLoadingDescription';
import CircularProgressLoading from '../../../components/Accessibility/CircularProgressLoading';
import FilterSelect from '../../../components/FilterSelect';
import LoadingApp from '../../../components/LoadingApp';
import { FilterInterface } from '../../../interfaces/entities/FilterInterface';
import { getPeriodoExtratoUtilizacao } from '../../../services/BeneficiarioService';
import { getExtratoCoparticipacao } from '../../../services/FinanceiroService';
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { base64toBlob } from '../../../utils/Base64ToBlob';
import AdviceContainer from './AdviceContainer';
import './styles.css';
import { sxButtonConsultar } from './sxProps';
import PageTitle from '../../../components/Accessibility/PageTitle';
import { mapMonthAbrevToFull } from '../../../utils/MonthMap';
import FeedbackModal from '../../SaudeOnline/AgendarConsulta/FeedbackModal';
import ModalFeedBack from '../../../components/ModalFeedBack';
import ErrorModal from './ErrorModal';

function ExtratoCoparticipacao() {

  const accessibility = useAccessibility();

  const [periodos, setPeriodos] = useState<FilterInterface[]>([]);
  const [periodoSelecionado, setPeriodoSelecionado] = useState<string>('');
  const [loadingPeriodo, setLoadingPeriodo] = useState<boolean>(false);
  const [loadingExtrato, setLoadingExtrato] = useState<boolean>(false);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    loadPeriodo();
  }, []);

  const loadPeriodo = () => {
    setLoadingPeriodo(true);
    getPeriodoExtratoUtilizacao()
      .then(response => {
        if (response?.data) {
          const periodos = response.data.map((periodo: { valor: any; descr: any; }) => {
            const [monthAbrev, year] = periodo.descr.split('/');
            const fullMonth = mapMonthAbrevToFull(monthAbrev);
            return {
              id: periodo.valor,
              descricao: periodo.descr,
              ariaDescricao: `${fullMonth} de ${year}`,
            };
          });

          setPeriodos(periodos);
          setLoadingPeriodo(false);
        }
      })
      .catch(console.log);
  }

  const consultarExtrato = () => {
    setLoadingExtrato(true);
    getExtratoCoparticipacao(periodoSelecionado)
      .then(response => {
        if (response?.data) {
          const pdf = response.data;
          const blob = base64toBlob(pdf.split(',')[1]);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        }
      })
      .catch(response => {
        const message = response?.data?.message;
        setErrorMessage(message ? message : '');
        setErrorModal(true);
      })
      .finally(() => {
        setLoadingExtrato(false);
      })
  }

  const handleCloseErrorModal = () => {
    setErrorModal(false);
  }

  return (
    <div className='container' aria-atomic>
      <AudioLoadingDescription loading={loadingPeriodo} />
      <PageTitle text="Extrato de Coparticipação" />

      <AdviceContainer />

      {loadingPeriodo &&
        <CircularProgressLoading />
      }

      {!loadingPeriodo &&
        <div className='filter-holder'>
          <div className="filter-row">
            <div className="filter-option">
              <FilterSelect title='Período' options={periodos} disabled={false} handleChange={setPeriodoSelecionado} />
            </div>
            <div className='consultar-button-holder'>
              <Button disabled={!periodoSelecionado} style={accessibility.buttonStyleAccessibility} variant='contained' sx={sxButtonConsultar} onClick={() => consultarExtrato()}>
                <Typography style={accessibility.buttonTextStyleAccessibility}>Consultar</Typography>
              </Button>
            </div>
          </div>
          <LoadingApp showLoading={loadingExtrato} />
        </div>
      }
      <ModalFeedBack
        showModal={errorModal}
        handleShowModal={handleCloseErrorModal}
        title={'Atenção'}
        subTitle={errorMessage || 'Extrato não localizado'}
        icon={'error'}
        showButtonModal={false}
        textButton={''}
        handleButtonModal={() => {}}
      />
    </div>

  )
}

export default ExtratoCoparticipacao